import React from 'react';
import Version2018 from './version-2018';
import Version2023 from './version-2023';

function MontanaForm(props) {
  const { version } = props;

  switch (version) {
    case 'mt_2018':
      return <Version2018 {...props} />;
    default:
      return <Version2023 {...props} />;
  }
}

export default MontanaForm;
